import { render, staticRenderFns } from "./XInputMetrics.vue?vue&type=template&id=76c948d9"
import script from "./XInputMetrics.vue?vue&type=script&lang=js"
export * from "./XInputMetrics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports